<template>
    <el-dialog title="Редактирование" :visible.sync="visibleModalModel" width="400px" :append-to-body="true" v-loading="isLoading">
        <AffiliateSaleForm v-if="affiliate_sale" mode="edit" @saved="onSaved" :sale="affiliate_sale"  />
    </el-dialog>
</template>

<script>

import AffiliateSaleForm from "./AffiliateSaleForm";
export default {
    name: "ModalEdit",
    components: {AffiliateSaleForm},
    props: ['visibleModal', 'affiliateSaleId'],
    data: () => ({
        isLoading: false,
        affiliate_sale: null,
    }),
    mounted() {
        this.fetch();
    },
    computed: {
        visibleModalModel: {
            get () { return this.visibleModal },
            set (value) { this.$emit('update:visibleModal', value) },
        },
    },
    methods: {
        onSaved(sale) {
            this.visibleModalModel = false;
            this.$emit('saved', sale);
        },
        fetch() {
            this.isLoading = true;
            axios.get('/api/affiliate_sales/' + this.affiliateSaleId)
                .then(res => {
                    this.affiliate_sale = res.data;
                    this.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
